<template>
  <div class="dashboard-container">
    <div ref="dashboard" class="dashboard">
      <Common />
      <Sidebar @menu-close="$refs['dashboard'].classList.remove('sidebar-visible')" />
      <Content @menu-click="$refs['dashboard'].classList.add('sidebar-visible')" />
    </div>
  </div>
</template>

<script>
import Common from '@/components/common/Common.vue'
import Sidebar from '@/components/dashboard/Sidebar.vue'
import Content from '@/components/dashboard/Content.vue'
export default {
  name: 'DashboardLayout',
  components: { 
    Common,
    Sidebar,
    Content,
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler(){
        if(this.$refs['dashboard']) this.$refs['dashboard'].classList.remove('sidebar-visible')
      },
    }
  }
}
</script>

<style lang="scss" scoped>

@include media-breakpoint-down(md) {
  .dashboard-container {
    > .dashboard {
      grid-template-columns: 100% !important;
      grid-template-rows: 100% !important;
      grid-template-areas: 
        'content'
        'content'
      !important;
      &.sidebar-visible {
        grid-template-areas: 
          'sideBar'
          'sideBar'
        !important;
      }
    }
  }
}
.dark-theme {
  .dashboard-container {
    background-color: $black;
  }
}
.dashboard-container {
  background-color: $white;
  height: 100%;
  width: 100%;
  > .dashboard {
    background-color: #{$primary}+'33';
    display: grid;
    padding: 1rem;
    transition: grid-template-columns 0.3s ease-in-out;
    grid-template-columns: 250px 1fr;
    grid-template-rows: 65px 1fr;
    grid-template-areas: 
      'sideBar    content'
      'sideBar    content'
    ;
    height: 100%;
    width: 100%;
    overflow: hidden;
    > .content {
      margin-left: 0px;
    }
  }
}
</style>